import { Injectable, inject } from '@angular/core';
import { IService } from '@scandium-oy/ngx-scandium';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SupportItem } from '../models/support-item.model';
import { ContractorsService } from './contractors.service';
import { FirestoreService } from './firestore.service';

const itemCollection = 'support-items';

@Injectable({
  providedIn: 'root',
})
export class SupportService implements IService<SupportItem> {
  private contractorsService = inject(ContractorsService);
  private firestore = inject(FirestoreService);

  async save(item: SupportItem) {
    if (this.contractorsService.contractorS() != null) {
      item.contractor = this.contractorsService.contractorS().guid;
    }
    return this.firestore.save(itemCollection, item);
  }

  async update(item: SupportItem) {
    return this.firestore.update(itemCollection, item);
  }

  async updateOnly(guid: string, value: object) {
    return this.firestore.updateOnly(itemCollection, guid, value);
  }

  async delete(item: SupportItem) {
    return this.firestore.softDelete(itemCollection, item);
  }

  get(guid: string): Observable<SupportItem> {
    return this.firestore.get<SupportItem>(itemCollection, guid);
  }

  getList(): Observable<SupportItem[]> {
    return this.firestore.getList<SupportItem>(itemCollection).pipe(
      map((items) => items?.filter((item) => item.deleted == null) ?? []),
      map((items) => {
        const contractor = this.contractorsService.contractorS()?.guid ?? null;
        if (contractor == null) {
          return items.filter((item) => item.contractor == null);
        }
        return items.filter((item) => item.contractor == null || item.contractor === contractor);
      }),
    );
  }
}
